// extracted by mini-css-extract-plugin
export default {"moreList":"index_moreList_2KguM","ulList":"index_ulList_5DFzz"};